import React from "react";
import { useSSE } from "./hooks/useSSE";

export const SSEManager = () => {
  // Initiating a Server-Sent Events (SSE) connection to receive real-time updates
  useSSE();

  return <></>;
};
